import { apiClient } from './base';

export const getCommissions = async (params = {}) => {
  try {
    const response = await apiClient.get('/call-center/commission', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCommissionById = async (id) => {
  try {
    const response = await apiClient.get(`/call-center/commission/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const finalizeCommission = async (settlementMonth) => {
  try {
    const response = await apiClient.post('/call-center/commission/finalize', { settlementMonth });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const completeCommission = async (id) => {
  try {
    const response = await apiClient.put(`/call-center/commission/${id}/complete`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStaffCommissionReport = async (params = {}) => {
  try {
    const response = await apiClient.get('/call-center/commission/staff-report', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reverseCommission = async (id) => {
  try {
    const response = await apiClient.delete(`/call-center/commission/${id}/finalization`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
